export const getDataFromLocalStorage = (key, defaultValue) => {
    const data = localStorage.getItem(key);
    return data === null ? defaultValue : JSON.parse(data);
};
